
import { Flex } from "@/kit/antipad-ui/Flex";
import { Skeleton } from "@chakra-ui/react";

export const WalletsPreloader = () => (
    <Flex direction="column" gap="xl" fullWidth>
        <div>
            <Skeleton startColor='#202020' endColor='#282828' height="100px" borderRadius="3xl" />
        </div>
        <div>
            <Skeleton startColor='#202020' endColor='#282828' height="100px" borderRadius="3xl" />
        </div>
    </Flex>
)